import {Preferences} from './user-preferences.model';
import {environment} from '@env/environment';

export class User {
    fullName: string;
    username: string;
    email: string;
    orgType: string;
    role: string;
    orgGuid: string;
    orgName: string;
    profilePhoto: string;
    primaryAdmin: boolean;
    mfaEnabled: boolean;
    mfaPhone: string;
    factorsList: UserMfaConfig[];
    guid: string;
    etxOrgId: number;

    preferences: Preferences;
    status: UserStatus;
    lastLogin: Date;
    lastPasswordChanged: Date;
    needToSetupMFA: boolean;
    phone: string;

    constructor(user: User = {} as User) {
        Object.assign(this, user);
    }

    static convertDirectoryUserToUser(userData: DirectoryUser) {
        return new User(<User>{
            fullName: userData.fullName,
            username: userData.email,
            email: userData.email,
            role: userData.role,
            orgGuid: userData.orgGuid,
            orgType: (userData.role === RoleType.APPLICATION_ADMIN) ? 'app_vendor' : 'district',
            mfaEnabled: userData.mfaEnabled,
            mfaPhone: userData.mfaPhone,
            factorsList: userData.factorsList,
            guid: userData.guid,
            status: userData.status,
            lastLogin: userData.lastLogin,
            lastPasswordChanged: userData.lastPasswordChanged,
            phone: userData.phone
        });
    }
}

export enum Gender {
    MALE = 'male',
    FEMALE = 'female'
}

export class DirectoryUser {
    guid: string;
    email: string;
    password: string;
    role: RoleType;
    fullName: string;
    phone: string;
    gender: Gender;
    orgGuid: string;
    isDeleting: boolean;
    mfaEnabled: boolean;
    mfaPhone: string;
    factorsList: UserMfaConfig[];
    status: UserStatus;
    lastLogin: Date;
    lastPasswordChanged: Date;
}

export enum RoleType {
    SYS_ADMIN = 'SYS_ADMIN',
    INSTITUTIONAL_ADMIN = 'INSTITUTIONAL_ADMIN',
    APPLICATION_ADMIN = 'APPLICATION_ADMIN',
    SERVICE_OPERATOR = 'SERVICE_OPERATOR'
}

export enum RoleTypeFriendlyName {
    SYS_ADMIN = 'System Administrator',
    INSTITUTIONAL_ADMIN =  'District Administrator',
    APPLICATION_ADMIN = 'App Vendor Admin',
    SERVICE_OPERATOR = 'Service Operator'
}

export enum RoleTypeFriendlyNameByOrgList {
    independent_school = 'Independent School Administrator',
    county = 'Head Admin',
    district = 'District Administrator',
    school = 'School Administrator',
    app_vendor = 'App Vendor Admin',
    root = 'System Administrator'
}

export enum OrgTypesList {
    independent_school = 'Independent School',
    county = 'County',
    district = 'District',
    school = 'School',
    app_vendor = 'Vendor',
    root = 'root'
}

export enum UserStatus {
    ACTIVE = 'ACTIVE',
    TO_BE_DELETED = 'TO_BE_DELETED',
    PASSWORD_RESET_REQUIRED = 'PASSWORD_RESET_REQUIRED',
    ETX_LOGIN_REQUIRED = 'ETX_LOGIN_REQUIRED'
}


export const UserStatusFriendlyName = {
    'ACTIVE': 'Active',
    'TO_BE_DELETED': 'Deactivated',
    'PASSWORD_RESET_REQUIRED': 'Password expired',
    'ETX_LOGIN_REQUIRED': 'District admin login blocked'
};

export enum UserMfaConfigName {
    SMS = 'VALIDATION_CODE_LOGIN',
    TOTP = 'TOTP_LOGIN'
}

export const UserMfaConfigFriendlyNameMap = new Map<UserMfaConfigName, string>([
    [UserMfaConfigName.SMS, 'SMS'],
    [UserMfaConfigName.TOTP, 'Authenticator App'],
]);

export const MFA_ORDER = [UserMfaConfigName.SMS, UserMfaConfigName.TOTP];

export class UserMfaConfig {
    name: UserMfaConfigName;
    enabled: boolean;
    phone: string;
}

export class MfaConfigs {
    guid: string;
    factorsList: UserMfaConfig[];
}

export const INVALID_PASSWORD_STATUS_CODE = 422;
export const INVALID_PASSWORD_ERROR_MESSAGE = 'You used this password recently. Please choose a different one.';
export const SEND_SMS_FAILED_STATUS_CODE = 409;
export const SCHOOL_PASSPORT_AUTH_COOKIE_NAME = environment.spOidcClientId + '_authzData';
export const NUMBER_OF_DAYS_TO_SHOW_NOTIFICATION_BEFORE_PASSWORD_EXPIRES = 14;
export const DEADLINE_TO_SET_UP_MFA_FOR_VENDORS = new Date(Date.UTC(2025, 1, 19));
